import { Component, OnInit, ViewChild } from '@angular/core';
import { AveriasService } from '../servicios/averias.service';
import { operadores } from '../entidades/entidades.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { SelectItem } from 'primeng/api';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { AnalyticsService } from '../servicios/analytics.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { NbCheckboxModule } from '@nebular/theme';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';

@Component({
    selector: 'app-operadores',
    templateUrl: './operadores.component.html',
    styleUrls: ['./operadores.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule, DropdownModule,
       MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule,
        MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, SpinnerComponent,
         MultiSelectModule, AgGridAngular, NbCheckboxModule],
    providers: [DatePipe],
})
export class OperadoresComponent implements OnInit {
  durationInSeconds = 3;

  operadoresEntidades: operadores[] = [];
  operadoresGrilla;
  tipoOperador: SelectItem[];
  clientes: SelectItem[];
  tipoOperadorSeleccionado;
  idOperadores: number;
  idTipoOperadores;
  idClienteCapturado;
  idCliente: number;
  clientesOK = false;
  clienteSeleccionado;
  TipoOperadoresOK = false;
  descripcionOperador;
  descripcionAbreviadaOperador;
  showSpinnerAlta = false;
  datosOperadores = [];
  showSpinner = false;
  showGrilla = false;
  dataset: any[] = [];
  columnDefinitions: ColDef[];//Column[];
  gridOptions: GridOption;
  
  showSpinnerGrillaModificar = false;
  showGrillaModificar = false;
  angularGridModificar: AngularGridInstance;
  columnDefinitionsModificar: ColDef[];//Column[];
  gridOptionsModificar: GridOption;
  datasetModificar: any[] = [];

  showSpinnerConsulta = false;
  showGrillaConsulta = false;
  angularGridConsulta: AngularGridInstance;
  columnDefinitionsConsulta: ColDef[];//Column[];
  gridOptionsConsulta: GridOption;
  datasetConsulta: any[] = [];


  gridObj: any;
  angularGrid: AngularGridInstance;
  dataView: any;
  firstForm: UntypedFormGroup;
  OperadoresSelect: SelectItem[];
  idOperadoresSelect;
  OperadoresSelectOK = false;
  OperadorSeleccionado;
  clienteModificarSeleccionado;
  descripcionOperadorModificar;
  descripcionAbreviadaOperadorModificar;
  operadoresDescripcion;
  operadorProcesado;
  showSpinnerModificar = false;
  idTipoOperadorModificado;
  eliminar = false;
  eliminarSeleccionado;
  tipoOperadorSeleccionadoModificar;

  @ViewChild('grilla1') grilla1!: AgGridAngular;
  @ViewChild('grilla2') grilla2!: AgGridAngular;
  @ViewChild('grilla3') grilla3!: AgGridAngular;
  

  constructor(private fb: UntypedFormBuilder, private AveriasService: AveriasService, 
    private _snackBar: MatSnackBar, public usersRol: PerfilesUsuarioService, 
    private svcAnalytics: AnalyticsService) { }

  ngOnInit(): void {
    this.firstForm = this.fb.group({
      firstCtrl: ['-', Validators.required],
    });
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.svcAnalytics.setAnalyticsPageView();
  }

  ngAfterViewInit(): void {
    this.consultarTipoOperadores();
    this.consultarClientes();
    // this.consultarOperadores();
    
    // this.traerDatos();
  }

  onChangeTab(event){
    if(event.tabTitle == "Alta"){
      this.consultarOperadores();
    }
    if(event.tabTitle == "Consulta"){
      this.consultarOperadoresConsulta();
    }
    if(event.tabTitle == "Modificación"){
      this.consultarOperadores();
      this.consultarOperadoresModificar();
    }
  }

  toggleEliminar(eliminar: boolean) {
    this.eliminar = eliminar;
  }

  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }

  consultarTipoOperadores() {
    // this.showSpinner = true;
    // this.showGrilla = false;
    this.AveriasService.getTipoOperador().subscribe(
      data => {
        this.tipoOperador = this.insertarTipoOperadores(data);
      });
  }
  insertarTipoOperadores(armarTipoOperadores) {
    let averiasTipoOperadores: Array<any> = [];
    armarTipoOperadores.content.forEach(element => {
      averiasTipoOperadores.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasTipoOperadores;
  };
  capturarTipoOperadores(event) {
    this.idTipoOperadores = event;
    this.TipoOperadoresOK = true;
  }

  consultarOperadoresConsulta() {
    this.showSpinnerConsulta = true;
    this.showGrillaConsulta = false;
    this.AveriasService.getOperadores().subscribe(
      data => {
        this.operadoresDescripcion = data;
        this.traerDatosConsulta();
        this.fillGrillaOperadoresConsulta();
      });
  }

  consultarOperadoresModificar() {
    this.showSpinnerGrillaModificar = true;
    this.showGrillaModificar = false;
    this.AveriasService.getOperadores().subscribe(
      data => {
        this.operadoresDescripcion = data;
        this.OperadoresSelect = this.insertarOperadores(data);
        this.traerDatosModificar();
        this.fillGrillaOperadoresModificar;
      });
  }

  consultarOperadores() {
    this.showSpinner = true;
    this.showGrilla = false;
    this.AveriasService.getOperadores().subscribe(
      data => {
        this.operadoresDescripcion = data;
        this.OperadoresSelect = this.insertarOperadores(data);
        this.traerDatos();
        this.fillGrillaOperadores();
        
      });
  }

  insertarOperadores(armarOperadores) {
    let averiasOperadores: Array<any> = [];
    armarOperadores.content.forEach(element => {
      averiasOperadores.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasOperadores;
  };

  capturarOperadores(event) {
    this.idOperadoresSelect = event;
    this.OperadoresSelectOK = true;
  }

  consultarClientes() {
    this.AveriasService.getClientes().subscribe(
      data => {
        this.clientes = this.insertarClientes(data);
      });
  }


  insertarClientes(armarClientes) {
    let listaCliente: Array<any> = [];
    armarClientes.content.forEach(element => {
      listaCliente.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return listaCliente;
  };

  capturarClientes(event) {
    this.idClienteCapturado = event;
    this.clientesOK = true;
  }

  altaOperador() {
    let operadores: operadores;

    if (this.descripcionOperador == null || this.descripcionOperador == "") {
      this.openSnackBar("Debe Completar el Nombre ❌");
    } else if (this.descripcionAbreviadaOperador == null || this.descripcionAbreviadaOperador == "") {
      this.openSnackBar("Debe Completar el Nombre Abreviado ❌");
    } else {
      operadores = {
        descripcion: this.descripcionOperador,
        descripcionAbreviada: this.descripcionAbreviadaOperador,
        idTipoOperador: this.tipoOperadorSeleccionado,
      }
      this.showSpinnerAlta = true;
      this.AveriasService.postOperadores(operadores).subscribe(data => {
        if (data["status"] == 201) {
          this.openSnackBar('Los cambios se han guardado correctamente');
        } else {
          this.openSnackBar('Ha ocurrido un error al guardarse los datos');
        }
        this.descripcionOperador = '';
        this.descripcionAbreviadaOperador = '';
        this.tipoOperadorSeleccionado = [];
        this.consultarTipoOperadores();
        this.showSpinnerAlta = false;
        this.showSpinner = false;
      })
    }
  }

  traerDatosConsulta() {
    let datosOperadores = this.operadoresDescripcion['content'];
    this.showSpinnerConsulta = true;
    this.showGrillaConsulta = false;
    let mockDataset: any = [];
      for (let i = 0; i < datosOperadores.length; i++) {
        mockDataset.push({
          id: datosOperadores[i].id,
          Descripcion: datosOperadores[i].descripcion,
          DescripcionAbreviada: datosOperadores[i].descripcionAbreviada,
          // TipoOperador: datosOperadores.content[i].tipoOperador.id == null? 0 : datosOperadores.content[i].tipoOperador.id,
          TipoOperador: datosOperadores[i].tipoOperador == null ? '' : datosOperadores[i].tipoOperador.descripcion
        });
      }
      this.datasetConsulta = mockDataset;
      this.fillGrillaOperadoresConsulta();
      this.showSpinnerConsulta = false;
      this.showGrillaConsulta = true;
  }

  fillGrillaOperadoresConsulta() {
    this.columnDefinitionsConsulta = [
      { //id: 'Descripcion', 
        headerName: 'Nombre', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'DescripcionAbreviada', 
        headerName: 'Nombre Abreviado', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'TipoOperador', 
        headerName: 'Operador', field: 'TipoOperador', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
    ];
    this.gridOptionsConsulta = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  }
  angularGridReadyConsulta(angularGrid: AngularGridInstance) {
    this.angularGridConsulta = angularGrid;
    this.dataView = angularGrid.dataView;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
    this.angularGridConsulta.resizerService.pauseResizer(false)
  }

  traerDatosModificar() {
    let datosOperadores = this.operadoresDescripcion['content'];
    this.showSpinnerGrillaModificar = true;
    this.showGrillaModificar = false;
    let mockDataset: any = [];
      for (let i = 0; i < datosOperadores.length; i++) {
        mockDataset.push({
          id: datosOperadores[i].id,
          Descripcion: datosOperadores[i].descripcion,
          DescripcionAbreviada: datosOperadores[i].descripcionAbreviada,
          // TipoOperador: datosOperadores.content[i].tipoOperador.id == null? 0 : datosOperadores.content[i].tipoOperador.id,
          TipoOperador: datosOperadores[i].tipoOperador == null ? '' : datosOperadores[i].tipoOperador.descripcion
        });
      }
      this.datasetModificar = mockDataset;
      this.fillGrillaOperadoresModificar();
      this.showSpinnerGrillaModificar = false;
      this.showGrillaModificar = true;
  }

  fillGrillaOperadoresModificar() {
    this.columnDefinitionsModificar = [
      { //id: 'Descripcion', 
        headerName: 'Nombre', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'DescripcionAbreviada', 
        headerName: 'Nombre Abreviado', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'TipoOperador', 
        headerName: 'Operador', field: 'TipoOperador', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
    ];
    this.gridOptionsConsulta = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  }
  angularGridReadyModificar(angularGrid: AngularGridInstance) {
    this.angularGridModificar = angularGrid;
    this.dataView = angularGrid.dataView;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
    this.angularGridModificar.resizerService.pauseResizer(false)
  }

  traerDatos() {
    let datosOperadores = this.operadoresDescripcion['content'];
    this.showSpinner = true;
    this.showGrilla = false;
    let mockDataset: any = [];
      for (let i = 0; i < datosOperadores.length; i++) {
        mockDataset.push({
          id: datosOperadores[i].id,
          Descripcion: datosOperadores[i].descripcion,
          DescripcionAbreviada: datosOperadores[i].descripcionAbreviada,
          // TipoOperador: datosOperadores.content[i].tipoOperador.id == null? 0 : datosOperadores.content[i].tipoOperador.id,
          TipoOperador: datosOperadores[i].tipoOperador == null ? '' : datosOperadores[i].tipoOperador.descripcion
        });
      }
      this.dataset = mockDataset;
      this.fillGrillaOperadores();
      this.showSpinner = false;
      this.showGrilla = true;
  }

  fillGrillaOperadores() {
    this.columnDefinitions = [
      { //id: 'Descripcion', 
        headerName: 'Nombre', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'DescripcionAbreviada', 
        headerName: 'Nombre Abreviado', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'TipoOperador', 
        headerName: 'Operador', field: 'TipoOperador', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
    ];
    this.gridOptions = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  }
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.dataView = angularGrid.dataView;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
    this.angularGrid.resizerService.pauseResizer(false)
  }

  modificarOperadores() {
    let operadores: operadores ; 

    if (this.eliminar) {
      this.AveriasService.deleteOperadores(this.operadorProcesado).subscribe(data => {
        if (data["status"] == 204) {
          this.openSnackBar('Los datos se han eliminado correctamente');
          this.descripcionOperadorModificar = '';
          this.descripcionAbreviadaOperadorModificar = '';
          this.operadorProcesado = '';
          this.tipoOperadorSeleccionadoModificar = '';
          this.consultarOperadores();
          this.consultarOperadoresModificar();
        } else {
          this.openSnackBar('Ha ocurrido un error al borrar los datos');
        }
        this.eliminarSeleccionado = false;
        this.eliminar = false;
      })
    } else {
      if (this.descripcionOperadorModificar == null || this.descripcionOperadorModificar == "") {
        this.openSnackBar("Debe Completar el Nombre ❌");
      } else if (this.descripcionAbreviadaOperadorModificar == null || this.descripcionAbreviadaOperadorModificar == "") {
        this.openSnackBar("Debe Completar el Nombre Abreviado ❌");
      } else if (this.operadorProcesado == null || this.operadorProcesado == "") {
        this.openSnackBar("Debe seleccionar un Operador ❌");
      } else {
        this.showSpinnerModificar = true;
        operadores = {
          descripcion: this.descripcionOperadorModificar,
          descripcionAbreviada: this.descripcionAbreviadaOperadorModificar,
          idTipoOperador: this.tipoOperadorSeleccionadoModificar,
      }
      this.AveriasService.putOperadores(this.operadorProcesado, operadores).subscribe(data =>{
        if(data["status"] == 200){
          this.openSnackBar('Los cambios se han guardado correctamente');
          // this.consultarOrigen();
           } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
        this.showSpinnerModificar = false;
        this.eliminarSeleccionado = false;
        this.eliminar = false;
        this.consultarOperadoresModificar();
      })
        this.descripcionOperadorModificar = '';
        this.descripcionAbreviadaOperadorModificar = '';
        this.operadorProcesado = '';
        this.tipoOperadorSeleccionadoModificar = '';
        this.eliminarSeleccionado = false;
    }
    }
  }
  obtenerDescripcionDropdown(idOperador: number) {
    let resp = this.operadoresDescripcion.content.find(n => n['id'] == idOperador);
    this.eliminarSeleccionado = false;
    this.eliminar = false; 
    this.descripcionOperadorModificar = resp['descripcion'];
    this.descripcionAbreviadaOperadorModificar = resp['descripcionAbreviada'];
    this.tipoOperadorSeleccionadoModificar = resp.tipoOperador['id'];
  }

    onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
    this.grilla2.api.sizeColumnsToFit();
    this.grilla3.api.sizeColumnsToFit();
  
  }
  
}
